// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_f1-0";
export var fileCarousel = "_f1-2";
export var removeFileButton = "_f1-1";